export const NEWS_FEEDS = ['announcements', 'promos', 'giveaways'];
export const DEFAULT_VISIBLE_ROWS = 5;

const collator = new Intl.Collator('en', { sensitivity: 'base', numeric: true });
const normalize = value => String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();

const haystack = page => normalize([page.title, page.short_name, page.tagline, page.feed_page ? '' : page.category_name, ...(Array.isArray(page.tags) ? page.tags : [])].join(' '));

export function splitHighlight(text, query) {
    const needle = normalize(query);
    const value = String(text || '');
    const index = needle ? value.toLowerCase().indexOf(needle) : -1;
    if (index < 0) return [{ text: value, match: false }];
    return [
        index > 0 && { text: value.slice(0, index), match: false },
        { text: value.slice(index, index + needle.length), match: true },
        index + needle.length < value.length && { text: value.slice(index + needle.length), match: false }
    ].filter(Boolean);
}

function splitPages(pages) {
    const featured = pages.filter(page => page.is_featured);
    const rest = pages.filter(page => !page.is_featured).sort((a, b) => collator.compare(a.title, b.title));
    return { featured, rest };
}

export function buildResourceMenu(categories = [], articles = [], { query = '' } = {}) {
    const needle = normalize(query);
    const matches = page => !needle || haystack(page).includes(needle);
    const pages = articles.filter(page => !page.post_feed);
    const feeds = NEWS_FEEDS.map(feed => pages.find(page => page.feed_page === feed)).filter(page => page && matches(page));
    const feedIds = new Set(pages.filter(page => page.feed_page).map(page => page.id));
    const browsable = pages.filter(page => !feedIds.has(page.id));

    const nodes = new Map(categories.map(category => [category.id, {
        id: category.id, parent_id: category.parent_id || null, name: category.name, slug: category.slug,
        ...splitPages(browsable.filter(page => page.category_slug === category.slug && matches(page))),
        children: []
    }]));
    const roots = [];
    for (const node of nodes.values()) {
        const parent = node.parent_id && nodes.get(node.parent_id);
        (parent ? parent.children : roots).push(node);
    }
    const finish = node => {
        node.children = node.children.map(finish).filter(Boolean);
        node.count = node.featured.length + node.rest.length + node.children.reduce((sum, child) => sum + child.count, 0);
        return node.count ? node : null;
    };
    const tree = roots.map(finish).filter(Boolean);
    const total = tree.reduce((sum, node) => sum + node.count, 0) + feeds.length;
    return { feeds, categories: tree, total };
}

export function pathToPage(menu, slug) {
    if (!slug) return [];
    const walk = (nodes, trail) => {
        for (const node of nodes) {
            const here = [...trail, node.id];
            if ([...node.featured, ...node.rest].some(page => page.slug === slug)) return here;
            const deeper = walk(node.children, here);
            if (deeper) return deeper;
        }
        return null;
    };
    return walk(menu.categories, []) || [];
}

export function visibleRows(node, { showAll = false, currentSlug = null, searching = false } = {}) {
    const currentIsHidden = node.rest.slice(DEFAULT_VISIBLE_ROWS).some(page => page.slug === currentSlug);
    if (showAll || searching || currentIsHidden || node.rest.length <= DEFAULT_VISIBLE_ROWS + 1) return { rows: node.rest, hidden: 0 };
    return { rows: node.rest.slice(0, DEFAULT_VISIBLE_ROWS), hidden: node.rest.length - DEFAULT_VISIBLE_ROWS };
}

export function findPage(articles, slug) {
    return articles.find(page => page.slug === slug) || null;
}
